import { keyCodes as r } from "../utils/utils.js";
import a from "lodash/get";
import l from "lodash/isFunction";
const o = {
  [r.up]: "prev",
  [r.down]: "next"
}, v = {
  [r.left]: "prev",
  [r.right]: "next"
}, h = {
  [r.left]: "prev",
  [r.right]: "next",
  [r.up]: "up",
  [r.down]: "down"
}, _ = {
  [r.home]: "first",
  [r.end]: "last"
}, d = {
  [r.pageUp]: "prevPage",
  [r.pageDown]: "nextPage"
}, p = {
  data() {
    return {
      travel_currentIndex: 0
    };
  },
  computed: {
    travel_config() {
      const t = a(this.$options, "$travel", null);
      return { ...{
        looped: !0,
        orientation: "horizontal",
        refName: "items"
      }, ...t };
    },
    travel_items() {
      return this.$refs[this.travel_config.refName] || [];
    },
    travel_length() {
      return this.travel_items.length;
    },
    travel_step() {
      return this.travel_config.grid.cols;
    },
    travel_nextIndex() {
      return this.travel_currentIndex + 1;
    },
    travel_prevIndex() {
      return this.travel_currentIndex - 1;
    },
    travel_aboveIndex() {
      return this.travel_currentIndex - this.travel_step;
    },
    travel_belowIndex() {
      return this.travel_currentIndex + this.travel_step;
    },
    travel_lastIndex() {
      return this.travel_length - 1;
    },
    travel_wrapOffset() {
      return this.travel_step * (this.travel_config.grid.rows - 1);
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.travel_currentIndex = this.travel_findNextInteractive(0, 1);
    });
  },
  beforeUnmount() {
    this.travel_currentIndex = 0;
  },
  methods: {
    bindTravel(t) {
      if (t.ended)
        return;
      const e = Object.assign(
        {},
        _,
        this.travel_config.hasPagination ? d : {}
      ), i = `travel_${{
        horizontal: Object.assign({}, e, v),
        vertical: Object.assign({}, e, o),
        grid: Object.assign({}, e, h)
      }[this.travel_config.orientation][t.keyCode]}`;
      l(this[i]) && this.travel_length > 1 && this[i](t), t.ended = !0;
    },
    travel_skipNonInteractive(t) {
      const e = this.travel_config.orientation === "grid";
      switch (t) {
        case this.travel_nextIndex:
          return this.travel_findNextInteractive(t, 1);
        case this.travel_prevIndex:
          return this.travel_findNextInteractive(t, -1);
        case 0:
          return this.travel_config.looped ? this.travel_findNextInteractive(t, 1) : this.travel_currentIndex;
        case (e && this.travel_aboveIndex):
          return this.travel_findNextInteractive(t, -this.travel_step);
        case (e && this.travel_belowIndex):
          return this.travel_findNextInteractive(t, this.travel_step);
        default:
          return t;
      }
    },
    travel_findNextInteractive(t, e) {
      const n = t >= this.travel_length || t < 0;
      return !this.travel_config.looped && n ? this.travel_currentIndex : t < 0 ? this.travel_findNextInteractive(this.travel_length - 1, -1) : this.travel_isInteractive(this.travel_items[t]) ? t : this.travel_findNextInteractive(t + e, e);
    },
    travel_isInteractive(t) {
      const e = a(t, "disabled", !1), n = a(t, "$attrs.tooltipOptions", !1);
      return !e || e && n;
    },
    travel_setIndex(t) {
      this.travel_currentIndex = this.travel_skipNonInteractive(t);
      const e = this.travel_items[this.travel_currentIndex];
      e.$el ? e.$el.focus() : e.focus();
    },
    travel_prev(t) {
      if (t.preventDefault(), this.travel_currentIndex === 0) {
        if (this.travel_config.looped) {
          this.travel_setIndex(this.travel_lastIndex);
          return;
        }
        return;
      }
      this.travel_setIndex(this.travel_prevIndex);
    },
    travel_next(t) {
      if (t.preventDefault(), this.travel_currentIndex === this.travel_lastIndex) {
        if (this.travel_config.looped) {
          this.travel_setIndex(0);
          return;
        }
        return;
      }
      this.travel_setIndex(this.travel_nextIndex);
    },
    travel_up(t) {
      t.preventDefault();
      const e = this.travel_currentIndex + this.travel_wrapOffset;
      if ([...Array(this.travel_step).keys()].includes(this.travel_currentIndex)) {
        if (this.travel_config.looped) {
          this.travel_setIndex(e);
          return;
        }
        return;
      }
      this.travel_setIndex(this.travel_aboveIndex);
    },
    travel_down(t) {
      t.preventDefault();
      const e = this.travel_currentIndex - this.travel_wrapOffset;
      if (Array.from({ length: this.travel_step }, (s, i) => i + this.travel_wrapOffset).includes(this.travel_currentIndex)) {
        if (this.travel_config.looped) {
          this.travel_setIndex(e);
          return;
        }
        return;
      }
      this.travel_setIndex(this.travel_belowIndex);
    },
    travel_first(t) {
      t.preventDefault(), this.travel_setIndex(0);
    },
    travel_last(t) {
      t.preventDefault(), this.travel_setIndex(this.travel_lastIndex);
    },
    travel_prevPage(t) {
      this.travel_config.prevPage && this.travel_config.prevPage(t, this.travel_currentIndex);
    },
    travel_nextPage(t) {
      this.travel_config.nextPage && this.travel_config.nextPage(t, this.travel_currentIndex);
    }
  }
};
export {
  p as default
};
//# sourceMappingURL=travel.js.map
